import SubFamilia from "@/api/SubFamilia";

export const sub_familia = {
    state: () => ({
    }),
    mutations: {
    },
    getters: {
    },
    actions: {
        async listSubFamilias() {
            return new Promise((resolve, reject) => {
                SubFamilia.all()
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        }
    }
}